import ArchiveListingModal from '../../../components/modals/archiveListingModal/ArchiveListingModal';
import UnarchiveListingModal from '../../../components/modals/unarchiveListingModal/UnarchiveListingModal';
import BulkActionDropdownNew from '../bulk-action-dropdown/BulkActionDropdownNew';
import ListingRow, { ListingDetails } from '../listing-row/ListingRow';
import ListingsHeader from '../listings-header/ListingsHeader';
import styles from './ListingsTable.module.css';

interface ListingsTableProps {
    listings: ListingDetails[];
    status: string;
}

const ListingsTable = ({
    listings,
    status
}: ListingsTableProps) => {
    return (
        <div className={styles.tableContainer}>
            <div className={styles.bulkDropdown}>
                <BulkActionDropdownNew status={status} />
            </div>
            <table className={styles.listingsContainer}>
                <ListingsHeader />
                {
                    listings.map((value, index) => {
                        return (
                            <ListingRow key={index} listing={value} />
                        )
                    })
                }
                <ArchiveListingModal />
                <UnarchiveListingModal />
            </table>
        </div>
    )
}

export default ListingsTable;
